import it from './it.json';
import en from './en.json';

export default { it, en };
